"use client";

import { ExternalLink } from "lucide-react";
import { HOWARD_COUNTY_LINKS } from "@/components/tenant/howard-county/howard-county-config";
import { useT } from "@/features/i18n/hooks/use-t";

export default function AccessibilityContent() {
  const { t } = useT();

  return (
    <div className="w-full space-y-10 pb-10 sm:pb-0">
      <section>
        <h2 className="mb-4 font-semibold text-lg">
          {t("accessibility.title")}
        </h2>
        <div className="space-y-4 text-muted-foreground leading-relaxed">
          <p>{t("accessibility.tilliXStatement1")}</p>
          <p>{t("accessibility.tilliXStatement2")}</p>
          <p>
            {t("accessibility.contactPrompt")}{" "}
            <a
              className="text-primary hover:underline"
              href="mailto:contact@tillisoftware.com"
            >
              {t("accessibility.contactEmail")}
            </a>
          </p>
        </div>
      </section>

      <section>
        <h2 className="mb-4 font-semibold text-lg">
          {t("accessibility.howardCountyTitle")}
        </h2>
        <a
          className="inline-flex items-center gap-1.5 text-primary text-sm hover:underline"
          href={HOWARD_COUNTY_LINKS.accessibility}
          rel="noopener noreferrer"
          target="_blank"
        >
          <ExternalLink className="h-3.5 w-3.5" />
          {t("accessibility.howardCountyLinkText")}
        </a>
      </section>
    </div>
  );
}
